import React, { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';

import { caption2Font } from '../Typography/Typography';

export interface IPeopleDetailSectionProps {
  title?: string;
  children?: ReactNode;
  className?: string;
}

const Section = styled.div`
  margin: 20px 23px;
`;

const SectionWrapper = styled.div`
  padding-bottom: 23px;
  border-bottom: 1px solid rgb(244, 244, 244);
`;

const SectionTitle = styled.h2`
  ${caption2Font}
  color: #666666;
  font-weight: 500;
  margin-bottom: 23px;
`;

export const PeopleDetailSection: FunctionComponent<IPeopleDetailSectionProps> = props => {
  const { title, className, children } = props;

  return (
    <Section className={className}>
      <SectionWrapper>
        {title && <SectionTitle>{title}</SectionTitle>}
        {children}
      </SectionWrapper>
    </Section>
  );
};

export default PeopleDetailSection;
